/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Search_PlaceholderInputs */

const cs_calendar_search_placeholder = /** @type {(inputs: Calendar_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-up, prohlídka…`)
};

const en_calendar_search_placeholder = /** @type {(inputs: Calendar_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow-up, viewing…`)
};

/**
* | output |
* | --- |
* | "Follow-up, viewing…" |
*
* @param {Calendar_Search_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_search_placeholder = /** @type {((inputs?: Calendar_Search_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Search_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_search_placeholder(inputs)
	return cs_calendar_search_placeholder(inputs)
});